<template>
  <!--对话框 获取员工列表-->
  <el-dialog
    :visible="isShow"
    :width="width"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :append-to-body="true"
    :show-close="false"
  >
    <div slot="title" class="dialog-title-container">
      <span class="title-label"
        ><i class="el-icon-user-solid"></i> 员工选择</span
      >
      <i class="el-icon-error" @click="close"></i>
    </div>
    <div class="dialog-search-container">
      <el-input size="mini" placeholder="请输入员工姓名" v-model="query.name">
        <template slot="prepend">搜索：</template>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchHandler"
        ></el-button>
      </el-input>
    </div>
    <div class="dialog-main-container">
      <el-table
        :data="ds"
        size="mini"
        height="410px"
        style="width: 100%;"
        stripe
        border
        header-row-class-name="list-header-row"
        row-class-name="list-row"
      >
        <el-table-column
          label="员工姓名"
          prop="name"
          header-align="center"
        ></el-table-column>
        <el-table-column
          label="职务"
          prop="position.title"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          label="选择"
          header-align="center"
          align="center"
          width="50"
        >
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              icon="el-icon-check"
              circle
              plain
              @click.stop="checkBack(scope.$index)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :page-size="query.pageSize"
          :page-count="query.pageSize"
          layout="prev, pager, next"
          :total="query.totalCount"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EzzDialogEmployee",
  props: {
    parent: {
      type: Object,
      default: () => null
    },
    width: {
      type: String,
      default: "50%"
    }
  },
  data: function() {
    return {
      isShow: false,
      ds: [],
      query: {
        employeeName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 1
      }
    };
  },
  mounted: function() {},
  methods: {
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getEmployees, _this.query, function(res) {
        let _json = res.data;
        _this.ds = _json.datalist;
      });
    },
    open: function() {
      this.loadData();
      this.isShow = true;
    },
    close: function() {
      this.isShow = false;
    },
    checkBack: function(_index) {
      let _employeeID = this.ds[_index].id;
      let _employeeName = this.ds[_index].name;
      this.parent.setEmployeeInfo(_employeeID, _employeeName);
      this.isShow = false;
    },
    // 搜索事件
    searchHandler: function() {
      this.query.pn = 1;
      this.loadData();
    }
  }
};
</script>
